import {
  Component,
  Input,
  OnInit,
  EventEmitter,
  Output,
  ElementRef,
  HostListener,
} from '@angular/core';
import * as moment from 'moment';

enum ModalidadFiltroCalendarioHora {
  Calendario,
  Hora,
}
@Component({
  selector: 'app-calendario-mes',
  templateUrl: './calendario-mes.component.html',
  styleUrls: ['./calendario-mes.component.scss'],
})
export class CalendarioMesComponent implements OnInit {
  @Output() onClickOutside = new EventEmitter();
  @Input() diaElegido;
  @Output() onFechaActualizada = new EventEmitter();

  ModalidadFiltroCalendarioHora = ModalidadFiltroCalendarioHora;
  modalidadFiltro: ModalidadFiltroCalendarioHora =
    ModalidadFiltroCalendarioHora.Calendario;

  horas = [
    '00:00',
    '01:00',
    '02:00',
    '03:00',
    '04:00',
    '05:00',
    '06:00',
    '07:00',
    '08:00',
    '09:00',
    '10:00',
    '11:00',
    '12:00',
    '13:00',
    '14:00',
    '15:00',
    '16:00',
    '17:00',
    '18:00',
    '19:00',
    '20:00',
    '21:00',
    '22:00',
    '23:00',
  ];

  horaElegida: string;

  mesActual: any[] = [];
  month_selected: number = moment().month() + 1;
  year_selected: number = moment().year();
  month_name_selected: any = moment(new Date());
  year_name_selected: any = moment(new Date());

  active = false;

  constructor(private eRef: ElementRef) {}

  ngOnInit(): void {
    moment.locale('es');
    this.actualizarCalendarioPequenio();
    this.horaElegida = this.diaElegido.format('HH:mm');
    setTimeout(()=>this.active = true, 1)
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (!this.eRef.nativeElement.contains(event.target) && this.active) {
      this.onClickOutside.emit(-1);
    }
  }

  lastMonth(): void {
    this.month_selected -= 1;
    if (this.month_selected < 1) {
      this.month_selected = 12;
      this.year_selected -= 1;
      this.year_name_selected.subtract(1, 'years');
    }
    this.month_name_selected.subtract(1, 'months');
    this.actualizarCalendarioPequenio();
  }

  actualizarCalendarioPequenio(): void {
    const year = this.year_selected;
    const month = this.month_selected;
    const tamMes = moment(
      `${year}-${month < 10 ? `0${month}` : month}`,
      'YYYY-MM'
    ).daysInMonth();

    var dias = [];

    for (let i = 1; i <= tamMes; i++) {
      let fecha = `${i < 10 ? `0${i}` : i}-${
        month < 10 ? `0${month}` : month
      }-${year}`;
      dias.push(moment(fecha, 'DD-MM-YYYY'));
    }

    const primerDia = parseInt(dias[0].format('d'));
    const ultimoDia = parseInt(dias[dias.length - 1].format('d'));

    // días del mes pasado
    for (let i = 0; i < primerDia; i++) dias.unshift({});
    // días del mes siguiente
    for (let i = ultimoDia; i < 6; i++) dias.push({});

    this.mesActual = [];
    let semana: any[] = [];

    dias.forEach((dia: any, index) => {
      semana.push(dia);
      if ((index + 1) % 7 === 0) {
        this.mesActual.push({
          id: `${index}-${month}-${year}`,
          semana,
        });
        semana = [];
      }
    });
  }

  nextMonth(): void {
    this.month_selected += 1;
    if (this.month_selected > 12) {
      this.month_selected = 1;
      this.year_selected += 1;
      this.year_name_selected.add(1, 'years');
    }
    this.month_name_selected.add(1, 'months');
    this.actualizarCalendarioPequenio();
  }

  public esElDiaActual(day) {
    return (
      day.date() === this.diaElegido.date() &&
      this.diaElegido.month() === day.month() &&
      day.year() === this.diaElegido.year()
    );
  }

  public elegirDia(day) {
    this.diaElegido = day;
    this.actualizarFecha();
  }

  public elegirDiaHora(nuevaModalidad: ModalidadFiltroCalendarioHora) {
    this.modalidadFiltro = nuevaModalidad;
  }

  public elegirHora(nuevaHora) {
    this.horaElegida = nuevaHora;
    this.actualizarFecha();
  }

  actualizarFecha() {
    this.diaElegido.set({
      hour: parseInt(this.horaElegida.split(':')[0]),
      minutes: parseInt(this.horaElegida.split(':')[1]),
    });
    this.onFechaActualizada.emit(this.diaElegido);
  }
}
